<template>
    <div class="error-page background-global">
      <Headline>Error 404</Headline>

      <b-col lg="2" md="3" cols="4" class="mx-auto">
        <img class="notfound-icon" src="../../assets/icons/404.png"/>
      </b-col>

      <ContentBox headline="">
        <p class="error">
          There seems to be no content on this page. <br/>
          If you think this is an error, please contact us: <br/>
          <a href="mailto:csslab@humtec.rwth-aachen.de">csslab@humtec.rwth-aachen.de</a>
        </p>
      </ContentBox>

    </div>
</template>

<script>

import ContentBox from '@/components/ContentBox.vue';
import Headline from '@/components/Headline.vue';

export default {
  name: 'Error404Page',
  props: {
    // will be set by router
    metaProp: Object,
  },
  // vue-head meta info
  metaInfo() {
    return this.metaProp;
  },
  components: {
    ContentBox,
    Headline,
  },
};
</script>
<style scoped>
.error-page {
  height: 500px;
  margin-top: 120px;
  margin-bottom: 0px;
}
.error {
  text-align: center;
}
.notfound-icon {
  width: 100%;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>
